export default {
  namespaced: true,

  state() {
    return {
      visible: false,
      message: "",
    };
  },
  getters: {},
  mutations: {
    SET_ERROR_TOOLTIP_SHOW: (state: any, message: string) => {
      state.visible = true;
      state.message = message;
    },
    SETSET_ERROR_TOOLTIP_HIDDEN: (state: any) => {
      state.visible = false;
      state.message = "";
    },
  },
  actions: {
    showToolTip: ({ commit }, message: string) => {
      commit("SET_ERROR_TOOLTIP_SHOW", message);
    },
    hideToolTip: ({ commit }) => {
      commit("SETSET_ERROR_TOOLTIP_HIDDEN");
    },
  },
};
